const mEditionMapMessages = {
  mEditionMapMessages: {
    messages: {
      noComments: 'Sin comentarios',
      noQuestions: 'Sin mensajes',
      notAnsered: 'Sin Responder'
    },

    quote: {
      firstText: 'Aún no tienes caminos creados en tu mapa.',
      secondText: 'Para interactuar con tus alumnos en la sección de mensajes primero debes crear caminos ingresando a'
    },

    submenu: {
      comments: 'Comentarios',
      questions: 'Mensajes'
    }
  }
}

export default mEditionMapMessages
